export const INITIAL_SIZE_PLAYER = { width: 480, height: 320 };
export const MIN_SIZE_PLAYER = { width: 480, height: 320 };
export const MAX_SIZE_PLAYER = { width: 1920, height: 1280 };

export const SIZE_EDIT = { width: 300, height: 240 };
